import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { PopoverDirective } from '@shared/directives/popover-directive';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopoverComponent {
  @Input() dismissible = true;
  @Input() enableShadow = true;
  @Input() width = '620px';
  @ViewChild('popover', { static: true }) popover: PopoverDirective;

  close(): void {
    this.popover.close();
  }
}
